import axiosClient from "./axiosClient";
import axios from 'axios';

const syncMeInvoices = async (startDate, endDate) => {
    return axiosClient.post("/meinvoice/sync/68e7c1b41850675dfd3e6709/date-range", {
        startDate,
        endDate,
        centerId: "67b4559db586fd615075e72e"
    });
};

const listMeInvoices = async (page, limit, search = "", filters = {}) => {
    return axiosClient.get("/meinvoice", {
        params: {
            page,
            limit,
            centerId: "67b4559db586fd615075e72e",
            search,
            ...filters,
        }
    });
};

const listExternalMeInvoices = async (page, limit, search = "") => {
    return axiosClient.get("/meinvoice", {
        params: {
            page,
            limit,
            centerId: "67b4559db586fd615075e72e",
            InvoiceSource: "external",
            search,
        }
    });
};

const listInternalMeInvoices = async (ParentInvoiceId) => {
    return axiosClient.get("/meinvoice", {
        params: {
            centerId: "67b4559db586fd615075e72e",
            InvoiceSource: "internal",
            ParentInvoiceId
        }
    });
};

const updateMeInvoice = async (id, data) => {
    return axiosClient.put(`/meinvoice/${id}`, data);
};

const checkDailyAmount = async ({
    sellerTaxCode,
    buyerTaxCode,
    date,
    startDate,
    endDate,
    threshold,
    pendingAmount,
    excludeInvoiceId,
    centerId,
}) => {
    const params = {};
    if (sellerTaxCode) params.sellerTaxCode = sellerTaxCode;
    if (buyerTaxCode) params.buyerTaxCode = buyerTaxCode;
    if (date) params.date = date;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (threshold != null) params.threshold = threshold;
    if (pendingAmount != null) params.pendingAmount = pendingAmount;
    if (excludeInvoiceId) params.excludeInvoiceId = excludeInvoiceId;
    if (centerId) params.centerId = centerId;
    return axiosClient.get("/meinvoice/check-daily-amount", { params });
};

const syncMeInvoiceItemsByDateRange = async (startDate, endDate) => {
    return axiosClient.post(`/meinvoice/sync/68e7c1b41850675dfd3e6709/items/date-range`, { startDate, endDate });
}

const runMeInvoiceBatches = async (batchLimit, itemType) => {
    return axiosClient.post("/meinvoice/batch/run-all", {
        batchLimit,
        itemType
    });
};

const runMeInvoiceBatchForTeacher = async (drivingTeacher, batchLimit, itemType) => {
    return axiosClient.post("/meinvoice/batch/run-for-teacher", {
        drivingTeacher,
        batchLimit,
        itemType
    });
};

const getMeInvoiceBatches = async (page, limit, search) => {
    let searchParam = search;
    if (search && typeof search === 'object') {
        try {
            searchParam = JSON.stringify(search);
        } catch (e) {
            searchParam = '';
        }
    }
    return axiosClient.get("/meinvoice/batch", {
        params: {
            _page: page,
            _limit: limit,
            search: searchParam
        }
    });
};

// Query-based filter: passes filters directly as query params to match controller
const queryMeInvoiceBatches = async (page, limit, query = {}) => {
    return axiosClient.get("/meinvoice/batch", {
        params: {
            _page: page,
            _limit: limit,
            ...query,
        }
    });
};

const updateStudentForBatch = async (batchId, drivingType) => {
    return axiosClient.put(`/meinvoice/batch/${batchId}/student`, {
        integrationId: '684da9ce05ded9ea98549675',
        drivingType
    });
};

const removeStudentFromBatch = async (batchId, integrationId = '684da9ce05ded9ea98549675') => {
    return axiosClient.delete(`/meinvoice/batch/${batchId}/student`, {
        data: { integrationId },
    });
};

// Đồng bộ GV-BC1 / XE-BC1 từ GetFly cho batch (dùng cho batch cũ chưa có 2 field).
const syncBc1ForBatch = async (batchId, { force = false, integrationId = '684da9ce05ded9ea98549675' } = {}) => {
    return axiosClient.put(`/meinvoice/batch/${batchId}/sync-bc1`, { integrationId, force });
};

const deleteMeInvoiceBatch = async (batchId, deletedReason = '') => {
    // Pass deletedReason in request body for DELETE
    return axiosClient.delete(`/meinvoice/batch/${batchId}`, {
        data: { deletedReason },
    });
};

const exportMeInvoiceBatches = async (filter) => {
    const token = localStorage.getItem("user-jwt-tk");
    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5050';
    
    return axios.post(`${baseURL}/meinvoice/batch/export`, {
        ...filter,
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        responseType: 'arraybuffer',
    });
};


const exportMeInvoices = async (payload) => {
    const token = localStorage.getItem("user-jwt-tk");
    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

    return axios.post(`${baseURL}/meinvoice/export/excel`, payload, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        responseType: 'arraybuffer',
    });
};

const exportPaymentVouchers = async (batchIds, layout = 'concat') => {
    const token = localStorage.getItem("user-jwt-tk");
    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

    return axios.post(`${baseURL}/meinvoice/batch/export-payment-vouchers`, {
        batchIds,
        layout,
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        responseType: 'arraybuffer',
    });
};

const MeInvoiceService = {
    listMeInvoices,
    listExternalMeInvoices,
    listInternalMeInvoices,
    syncMeInvoices,
    updateMeInvoice,
    checkDailyAmount,
    runMeInvoiceBatches,
    runMeInvoiceBatchForTeacher,
    getMeInvoiceBatches,
    queryMeInvoiceBatches,
    syncMeInvoiceItemsByDateRange,
    updateStudentForBatch,
    removeStudentFromBatch,
    syncBc1ForBatch,
    deleteMeInvoiceBatch,
    exportMeInvoiceBatches,
    exportMeInvoices,
    exportPaymentVouchers,
};

export default MeInvoiceService;
